var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 15.625C7.63071 15.625 8.75 14.5057 8.75 13.125C8.75 11.7443 7.63071 10.625 6.25 10.625C4.86929 10.625 3.75 11.7443 3.75 13.125C3.75 14.5057 4.86929 15.625 6.25 15.625Z",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5C2.93663 16.9178 3.5028 16.4453 4.15369 16.1199C4.80457 15.7944 5.52229 15.625 6.25 15.625C6.97771 15.625 7.69543 15.7944 8.34631 16.1199C8.9972 16.4453 9.56337 16.9178 10 17.5",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.5C7.63071 7.5 8.75 6.38071 8.75 5C8.75 3.61929 7.63071 2.5 6.25 2.5C4.86929 2.5 3.75 3.61929 3.75 5C3.75 6.38071 4.86929 7.5 6.25 7.5Z",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.375C2.93663 8.79283 3.5028 8.32031 4.15369 7.99487C4.80457 7.66943 5.52229 7.5 6.25 7.5C6.97771 7.5 7.69543 7.66943 8.34631 7.99487C8.9972 8.32031 9.56337 8.79283 10 9.375",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.625C15.1307 15.625 16.25 14.5057 16.25 13.125C16.25 11.7443 15.1307 10.625 13.75 10.625C12.3693 10.625 11.25 11.7443 11.25 13.125C11.25 14.5057 12.3693 15.625 13.75 15.625Z",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C10.4366 16.9178 11.0028 16.4453 11.6537 16.1199C12.3046 15.7944 13.0223 15.625 13.75 15.625C14.4777 15.625 15.1954 15.7944 15.8463 16.1199C16.4972 16.4453 17.0634 16.9178 17.5 17.5",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5C15.1307 7.5 16.25 6.38071 16.25 5C16.25 3.61929 15.1307 2.5 13.75 2.5C12.3693 2.5 11.25 3.61929 11.25 5C11.25 6.38071 12.3693 7.5 13.75 7.5Z",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.375C10.4366 8.79283 11.0028 8.32031 11.6537 7.99487C12.3046 7.66943 13.0223 7.5 13.75 7.5C14.4777 7.5 15.1954 7.66943 15.8463 7.99487C16.4972 8.32031 17.0634 8.79283 17.5 9.375",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2d173396882f6173cc070b23b13994f6.svg";
export { ForwardRef as ReactComponent };